<template lang="pug">
canvas#preview-layer(ref="preview")
</template>

<script>
let sc
import CanvasGen from "@/canvas"
import CanvasMixin from "./CanvasMixin"
export default {
  name: "PreviewCanvas",
  components: {},
  mixins: [CanvasMixin],
  props: {
    active: { type: String },
    board: { type: Array }
  },
  data() {
    return {
      mx: -1,
      my: -1
    }
  },
  created() {
    this.canvasTiles = CanvasGen(this.$state.scale, this.$state.scale * this.$tileSize, this.$state.scale * this.$dropSize)
  },
  mounted() {
    this.canvasKey = "preview"
    this.alpha = true
    this.onInitialize = this.initializePreview
  },
  watch: {
    mousePoint(pt, pp) {
      let scale = value => value * this.scaledTile

      let x = 0
      let y = 0
      let current = this.board[pt.x][pt.y].c
      let prevent = !this.$state.isBuildMode && ["sr", "sl", "tul", "tur", "ibl", "ibr", "itr", "itl"].includes(current)

      // remove any existing previews that are showing
      if (pp) {
        x = scale(pp.x)
        y = scale(pp.y)

        // over clear of island and tub
        sc.clearRect(x, y, this.scaledTile * 2, this.scaledTile * 2)
      }
      if (prevent || this.$state.hasFinished) {
        return
      }
      // show new preview
      if (pt.x >= 0 && pt.y >= 0) {
        x = scale(pt.x)
        y = scale(pt.y)

        let _c = this.canvasTiles[this.active]

        let w = ["tul", "tur"].includes(this.active) || this.active.startsWith("i") ? 2 : 1
        let h = this.active.startsWith("i") ? 2 : 1

        if (!this.$state.isReplacing) sc.drawImage(_c, x, y)
        sc.fillRect(x, y, this.scaledTile * w, this.scaledTile * h)
      }
    }
  },
  methods: {
    initializePreview(ctx) {
      sc = ctx

      sc.fillStyle = "rgba(0,0,0,.2)"
      if (this.$state.showPreview) this.initializeBoard()
    },
    onMouseOver(e) {
      this.mx = e.offsetX
      this.my = e.offsetY
    },
    onMouseOut() {
      sc.clearRect(0, 0, sc.canvas.width, sc.canvas.height)
    }
  },
  computed: {
    mousePoint() {
      let x = Math.floor(this.mx / this.scaledTile)
      let y = Math.floor(this.my / this.scaledTile)
      return { x, y }
    }
  }
}
</script>

<style lang="scss" scoped></style>
